import removeCountry from './remove-country';

/**
 * Translates the Google AutocompletePrediction object to a simplified object.
 *
 * AutocompletePrediction specifications:
 * https://developers.google.com/maps/documentation/javascript/reference#AutocompletePrediction
 */
export default function predictionAdapter(prediction) {
    return {
        matchedSubstrings: prediction.matched_substrings,
        name: removeCountry(prediction.description),
        placeId: prediction.place_id,
    };
}
